import { useState } from "react";
import Layout from "../Frames/Layout"
import Grid from "../Tools/Grid";
import { useEffect } from "react";
import API from "../../services/API/API";
import moment from "moment";
import { Button, IconButton, Rating, Stack, Typography } from "@mui/material";
import { Reply, ZoomIn } from "@mui/icons-material";
import Modal from "../Tools/Modal";

export default function Reviews(){

    const columns = [{
            field: 'createdAt',
            headerName: 'Date',
            type: 'date',
            width: 150,
            valueGetter: i => moment(i.row.createdAt).toDate(),
            renderCell: i => moment(i.value).format('DD/MM/YYYY à HH:mm'),
            aggregable: false,
            groupable: false,
        },
        {
            field: 'course',
            headerName: 'Formation',
            width: 500,
            valueGetter: i => i.row.course?.title,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'rating',
            headerName: 'Note',
            width: 150,
            type: 'number',
            valueGetter: i => i.row.rating,
            renderCell: i => <Rating value={i.value} readOnly/>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'zoom',
            headerName: 'Voir',
            width: 60,
            valueGetter: i => i.row.id,
            renderCell: i => 
                <IconButton size='small' onClick={() => setModal(i.row)}>
                    <ZoomIn />
                </IconButton>,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'comment',
            headerName: 'Commentaire',
            width: 400,
            valueGetter: i => i.row.comment,
            aggregable: false,
            groupable: false,
        },
        {
            field: 'reply',
            headerName: 'Répondre',
            width: 80,
            valueGetter: i => i.row.user?.email,
            renderCell: i => 
                <IconButton href={'mailto:' + i.value} size='small'>
                    <Reply/>
                </IconButton>,
            aggregable: false,
            groupable: false,
        },
    ];

    const [items, setItems] = useState([])

    const [modal, setModal] = useState(false)

    useEffect(() => {

        API.get('/teachers/me/reviews')
            .then(r => setItems(Array.isArray(r.data) ? r.data : []))

    }, [])


    return <Layout tab='reviews' menu='main' title='Avis des apprenants'>

        <Grid 
            id='reviewsGrid'
            columns={columns}
            rows={items}
            toolbar
        />

        <Modal
            title="Avis"
            open={modal ? true : false}
            onClose={() => setModal(false)}
            noActions
        >
            <Stack spacing={1} alignItems='flex-start'>

                <Rating value={modal.rating} readOnly/>

                <Typography variant='span'>{modal.comment}</Typography>

                <Button startIcon={<Reply />} href={'mailto:' + modal.user?.email}>
                    Répondre
                </Button>

            </Stack>
        </Modal>

    </Layout>
}